<script>
  import Vue from 'vue'

  export default Vue.extend({
    mounted() {
      this.$emit('mounted')
    },

    render() {
      return this.$slots.default
    },
  })
</script>
